import React from 'react';
import {
  FDBox,
  FDHeadlineText,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { DataValueMap } from 'Helpers/Testing';
import classNames from 'classnames';
import TimelineConnector from './TimelineConnector';

const useStyles = makeStyles(theme => ({
  timelineEventDot: {
    height: '15px',
    width: '15px',
    backgroundColor: theme.palette.facet.primaryBlue,
    borderRadius: '50px',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

export default function DesktopTimelineItem({
  itemResource, month, timelineCardComponent, isFirstItem, isLastItem,
}) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const TimelineCardComponent = timelineCardComponent;

  return (
    <FDStack direction={'row'}>
      <FDBox minWidth={'150px'} alignSelf={'center'}>
        <FDStack direction={'column'} alignItems={'flex-end'}>
          {month !== '' ? <FDHeadlineText {...DataValueMap.init('timeline-month').build()} size="md" value={month} /> : null}
        </FDStack>
      </FDBox>
      <FDStack direction={'column'} paddingX={3}>
        <Box className={classNames(classes.timelineConnector, classes.timelineConnectorDimensions)} />
        <TimelineConnector />
        <Box className={classes.timelineEventDot} />
        <TimelineConnector isVisible={!isLastItem} />
      </FDStack>
      <FDBox paddingX={6} paddingY={8} alignSelf={'center'} width={'100%'}>
        <TimelineCardComponent resource={itemResource} expanded={isFirstItem} />
      </FDBox>
    </FDStack>
  );
}

DesktopTimelineItem.defaultProps = {
  month: '',
  isFirstItem: false,
  isLastItem: false,
};

DesktopTimelineItem.propTypes = {
  itemResource: PropTypes.object.isRequired,
  month: PropTypes.string,
  timelineCardComponent: PropTypes.element.isRequired,
  isFirstItem: PropTypes.bool,
  isLastItem: PropTypes.bool,
};
